import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Create an async thunk to fetch market data
export const fetchMarketDataHistory = createAsyncThunk(
  'marketDataHistory/fetchMarketDataHistory',
  async ({symbol,timeframe,bars}, { rejectWithValue }) => {

      // let sym = symbol? symbol : 'BTCUSD.ex1'
      let sym = symbol ? (symbol.endsWith('.') ? symbol.slice(0, -1) : symbol) : 'BTCUSD.ex1';
    try {
      // Fetch the OHLC data from the Binance API
      console.log(`selected symbol is ${sym} and timeframe is ${timeframe} for days ${bars}`);
      
      const response = await axios.get(
        // `https://5csb.w.time4vps.cloud:8000/ohlc/?symbol=${sym}&timeframe=${timeframe}&days=${days}`
        `https://api.brokercheap.com:8040/newapp/ohlc/?symbol=${sym}&timeframe=${timeframe}&bars=${bars}`
        //         `https://api.brokercheap.com/newapp/ohlc/?symbol=${sym}&timeframe=${timeframe}&bars=${bars}`

      );
      const data = response?.data
      
      // console.log('res',data?.data);
      
      return data?.data; // Make sure to return data from the response
    } catch (error) {
      // If there's an error, reject the value with the error message
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// Create the Redux slice
const marketDataHistorySlice = createSlice({
  name: 'marketDataHistory',
  initialState: {
    data: [], // Initialize the data array
    status: 'idle', // Initial status is idle
    error: null, // No error initially
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // When the fetch is in progress
      .addCase(fetchMarketDataHistory.pending, (state) => {
        state.status = 'loading'; // Set status to 'loading'
      })
      // When the fetch is successful
      .addCase(fetchMarketDataHistory.fulfilled, (state, action) => {
        state.status = 'succeeded'; // Set status to 'succeeded'
        state.data = action.payload; // Store the fetched data in the state
      })
      // When the fetch fails
      .addCase(fetchMarketDataHistory.rejected, (state, action) => {
        state.status = 'failed'; // Set status to 'failed'
        state.error = action.payload || action.error.message; // Store the error message
      });
  },
});

export default marketDataHistorySlice.reducer;